module.exports = __webpack_public_path__ + "img/chips1000.9118c914.webp";